import type { TDocumentType } from 'api/swagger';

export const getTagColor = (type: TDocumentType): string => {
  switch (type) {
    case 'ex1':
    case 'cds':
    case 't1':
    case 'ens':
    case 'barcode':
    case 'gmr':
    case 'elo':
      return 'success';
    case 'cmr':
    case 'deliveryNote':
    case 'invoice':
    case 'cargoPhoto':
    case 'packingList':
    case 'order':
      return 'processing';
    case 'none':
      return 'default';
    default:
      return 'default';
  }
};
